import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';

const MapViewButtons = observer(() => (
  <div className='map-button-switcher toggle-buttons'>
    <a
      className={store.projectDetailsMap.setToggleButtonClass('terrain')}
      onClick={() =>
        store.projectDetailsMap.setMapView(
          'terrain',
          store.projectDetailsMap.terrainView
        )
      }
    >
      Terrain
    </a>

    <a
      className={store.projectDetailsMap.setToggleButtonClass('satellite')}
      onClick={() =>
        store.projectDetailsMap.setMapView(
          'satellite',
          store.projectDetailsMap.satelliteView
        )
      }
    >
      Satellite
    </a>
  </div>
));

export default MapViewButtons;
